import { createSlice } from "@reduxjs/toolkit";
import { transformKeys } from "../../_helper";

const initialState = {
  AllPackagesByCategoryData: [],
  packageCategoryName: "",
  partnerTypeName: "",
  isLoading: false,
  error: "",
  pagination: {},
};

export const AllPackagesByCategorySlice = createSlice({
  name: "AllPackagesByCategoryData",
  initialState,
  reducers: {
    setAllPackagesByCategoryData: (state, action) => {
      let packageData;
      if (action?.payload?.data?.original?.data?.length > 0) {
        packageData =
          action?.payload?.data?.original?.data.map((d) => transformKeys(d)) ||
          [];
      }

      const handlePackageData = packageData?.map((p) => {
        const handleCourses = p.courses.map((c) => c.courseName).join(" , ");
        const handleIsActive = p.is_active === 1 ? "Active" : "Inactive";
        const handleIsPvActive = p.pv_active === 1 ? "Active" : "Inactive";
        return {
          ...p,
          courses: handleCourses,
          is_active: handleIsActive,
          pv_active: handleIsPvActive,
        };
      });
      state.AllPackagesByCategoryData = handlePackageData;
      state.packageCategoryName =
        action.payload.data.original.packageCategoryName;
      state.partnerTypeName = action.payload.data.original.partnerTypeName;
      state.pagination = {
        last_page: action.payload.data.original.pagination?.last_page,
        current_page: action.payload.data.original.pagination?.current_page,
      };
    },
    clearAllPackagesByCategoryData: (state) => {
      state.AllPackagesByCategoryData = [];
      state.pagination = {};
      state.partnerTypeName = "";
      state.packageCategoryName = "";
      state.error = "";
      state.isLoading = false;
    },
    catchError: (state, action) => {
      state.error =
        action.payload.message ||
        "un expected error while fetching All Packages By Category Data";
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
  },
});

export const {
  setAllPackagesByCategoryData,
  clearAllPackagesByCategoryData,
  catchError,
  setLoading,
} = AllPackagesByCategorySlice.actions;
export default AllPackagesByCategorySlice.reducer;
